import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, Gift } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEAD_MAGNET_TITLE = "10 błędów w firmie transportowej";

export default function LeadMagnet() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Podaj poprawny adres e-mail");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, {
        email,
        name: name || null,
        lead_magnet: LEAD_MAGNET_TITLE,
      });
      setSent(true);
      toast.success("Super! Zapiszemy Cię i wyślemy materiał mailem.");
    } catch (err) {
      toast.error("Nie udało się zapisać. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="lead-magnet"
      data-testid="lead-magnet-section"
      className="relative py-20 md:py-28"
    >
      <div className="container-x">
        <div className="relative border border-[rgba(212,169,74,0.3)] bg-gradient-to-br from-[#141210] via-[#0f0d0a] to-[#141210] p-10 md:p-16 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[var(--gold)] opacity-[0.05] blur-3xl" />
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
               style={{
                 backgroundImage:
                   "radial-gradient(circle at 1px 1px, var(--gold) 1px, transparent 0)",
                 backgroundSize: "24px 24px",
               }}
          />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 border border-[var(--gold)] flex items-center justify-center">
                  <Gift className="text-[var(--gold)]" size={18} />
                </div>
                <span className="eyebrow">Bezpłatny PDF</span>
              </div>
              <h2 className="h-display mt-6 text-[clamp(30px,4vw,52px)]">
                10 błędów w firmie transportowej,{" "}
                <span className="gold-gradient-text italic">
                  które kosztują Cię tysiące złotych
                </span>
              </h2>
              <p className="mt-6 text-[16px] leading-relaxed text-[#b8b3a7] max-w-xl">
                Zbiór konkretnych przykładów z realnych firm — z komentarzem,
                jak te błędy rozpoznać i ile kosztują rocznie. Dostaniesz PDF
                prosto na e-mail. Bez spamu, bez reklam.
              </p>
            </div>

            <div className="lg:col-span-5">
              {sent ? (
                <div
                  data-testid="lead-success"
                  className="text-center py-10 border border-[var(--gold)] bg-[rgba(212,169,74,0.05)]"
                >
                  <Download className="text-[var(--gold)] mx-auto mb-4" size={36} />
                  <h3 className="font-display text-[24px] text-[#f5f1e8]">
                    Sprawdź skrzynkę
                  </h3>
                  <p className="mt-3 text-[14px] text-[#b8b3a7]">
                    W ciągu kilku minut otrzymasz e-mail z PDF-em.
                  </p>
                </div>
              ) : (
                <form onSubmit={submit} data-testid="lead-form" className="space-y-5">
                  <div>
                    <label className="lbl" htmlFor="lead-name">Imię</label>
                    <input
                      id="lead-name"
                      data-testid="lead-input-name"
                      type="text"
                      className="field"
                      placeholder="Twoje imię"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="lbl" htmlFor="lead-email">E-mail *</label>
                    <input
                      id="lead-email"
                      data-testid="lead-input-email"
                      type="email"
                      required
                      className="field"
                      placeholder="twoj@email.pl"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    data-testid="lead-submit"
                    className="btn-gold w-full justify-center disabled:opacity-60"
                  >
                    {loading ? "Wysyłam..." : "Wyślij mi PDF"}
                    <Download size={16} />
                  </button>
                  <p className="text-[11px] text-[#7a766d] text-center tracking-wide">
                    Twój e-mail jest bezpieczny. Możesz wypisać się w każdej chwili.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
